import ApiService from "./apiservice";

export const VacationService = {
    PersonVacationList(payload) {
        return ApiService.get("Vacation/PersonVacationList", payload);
    },
    GetTotalVacationRemainDetail(payload) {
        return ApiService.get("Vacation/GetTotalVacationRemainDetail", payload);
    },
    GetVacationRemainDetail(payload) {
        return ApiService.get("Vacation/GetVacationRemainDetail", payload);
    },
    AddVacation(payload) {
        return ApiService.post("AddVacation", payload);
    },
    GetWebVacationTypeList() {
        return ApiService.get("Vacation/GetWebVacationTypeList");
    },
    GetAllVacationTypeList() {
        return ApiService.get("vacation/GetAllVacationTypeList");
    },
    GetVacationDetailForPerson(payload) {
        return ApiService.get("Vacation/GetVacationDetailForPerson", payload);
    },
    GetVacationDetailForAdmin(payload) {
        return ApiService.get("Vacation/GetVacationDetailForAdmin", payload);
    },
    OprationOnVacationArchive(payload) {
        return ApiService.post("OprationOnArchive", payload);
    },
    GetVacationListForAdmins(payload) {
        return ApiService.get("Vacation/GetVacationListForAdmins", payload);
    },
    OprationOnVacationRequest(payload) {
        return ApiService.post("OprationOnRequest", payload);
    },
    GetApproveDegree(payload) {
        return ApiService.get("Vacation/GetApproveDegree", payload);
    },
    GetRemainMorakhasiUntilNow(params) {
        return ApiService.get("Vacation/GetRemainMorakhasiUntilNow", params);
    },
    GetHourlyVacationCountAndLength(params) {
        return ApiService.get("Vacation/GetHourlyVacationCountAndLength", params);
    },
    GetPeriodVacationDetail(params) {
        return ApiService.get("Vacation/GetPeriodVacationDetail", params);
    },
};